import { render, staticRenderFns } from "./bylineShareComponent.vue?vue&type=template&id=4875af08&scoped=true&"
import script from "./bylineShareComponent.vue?vue&type=script&lang=js&"
export * from "./bylineShareComponent.vue?vue&type=script&lang=js&"
import style0 from "./bylineShareComponent.vue?vue&type=style&index=0&id=4875af08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875af08",
  null
  
)

export default component.exports